/**
 * @module components\ghInput\selectionInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";
import { namespace } from "vuex-class";
import { Watch } from "vue-property-decorator";
const module = namespace("dbModule");
@Component
export default class SelectionInput extends InputBase {
  @module.State(state => state.columnsSource)
  private sources: { [key: string]: IColumnSourceState };

  @module.State(state => state.currentColumnChangedId)
  private changedColumnId: string;

  @module.Action("fetchColumnSource")
  private fetch;

  private get selected() {
    let value = this.value;
    if (value && this.items) {
      if (this.prop.sourceItemValue) {
        let items = this.items as IndexObject[];
        if (items.length > 0) {
          if (Array.isArray(value) && this.prop.multiple) {
            let array = value as any[];
            return items.filter(
              item => array.indexOf(item[this.prop.sourceItemValue]) >= 0
            );
          } else if (value instanceof Object) {
            return items.find(
              item => item[this.prop.sourceItemValue] === value
            );
          }
        }
      }
    }
    return value;
  }

  private set selected(val) {
    let value = val;
    let text = val;
    if (Array.isArray(val) && this.prop.multiple) {
      let array = val as any[];
      if (array.length > 0) {
        if (this.prop.sourceItemValue) {
          value = array.map(item => item[this.prop.sourceItemValue]);
        }
        if (this.prop.sourceItemText) {
          let texts = array.map(item => item[this.prop.sourceItemText]);
          text = texts.reduce((x, y) => x + "," + y);
        }
      } else {
        value = null;
        text = "";
      }
    } else if (val instanceof Object && this.prop.sourceItemValue) {
      value = val[this.prop.sourceItemValue];
      if (this.prop.sourceItemText) {
        text = val[this.prop.sourceItemText];
      }
    }
    if (!val) {
      text = "";
    }

    this.value = value;
    if (this.model) {
      if (this.prop.valueColumn && this.prop.valueColumn !== this.prop.value) {
        this.$set(this.model, this.prop.valueColumn, value);
      }
      if (this.prop.textColumn) {
        this.$set(this.model, this.prop.textColumn, text);
      }
    }
  }

  private get loading() {
    if (this.sources && this.prop.Id) {
      let source = this.sources[this.prop.Id];
      if (source) {
        return source.loading;
      }
    }
    return false;
  }

  private items: Array<{}> | any = null;

  private refresh() {
    this.fetch(this.prop.Id);
  }

  @Watch("sources")
  private observeChangedColumnId() {
    if (this.prop && this.prop.Id) {
      if (this.prop.Id === this.changedColumnId) {
        if (this.sources[this.prop.Id]) {
          this.items = this.sources[this.prop.Id].dataSource;
        }
      }
    }
  }

  created() {
    if (!this.items || this.items.length === 0) {
      this.refresh();
    }
  }

  private clearValue() {
    this.selected = "";
  }
}
